import React, { useState } from "react";
import starIcon from "./images/star.svg";
import cartIcon from "./images/add-to-cart.svg";
import vegIcon from "./images/veg.png";
import nonVegIcon from "./images/non-veg.png";
import notAvailable from "./images/not-available.svg";
import axios from "axios";
import { isAuthenticated } from "../../pages/login/auth/auth";
import addedIcon from "./images/added.svg";
import { API, imageLocation } from "../../Api";
import swal from "sweetalert";
import loadingIcon from "./images/loading.png";
import { EncryptCartData, DecryptCartData } from "./helper";

export default function Pcard2(props) {
  const [add, setAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  const quantity = 1;

  // const alrt = () => {
  //   swal({
  //     text: "Added to cart",
  //     button: {
  //       text: "ok",
  //       className: "swal-btn",
  //     },
  //     className: "swal-alert",
  //     icon: "success",
  //     timer: 2500,
  //   });
  // };

  const handleAddToCart = () => {
    setLoading(true);
    //  Handle add to cart functionality goes here
    const { token, data } = isAuthenticated();

    if (isAuthenticated()) {
      axios({
        method: "post",
        url: `${API}cart`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          user_id: data.user.number,
          product_id: props.id,
          quantity: quantity,
          name: props.name,
          veg: props.veg,
          mrp: props.mrp,
          sellingPrice: props.sellingPrice,
          coverImage: props.coverImage,
          unit: props.unit,
          packaged: props.packaged,
        },
        validateStatus: (status) => {
          return true; //status === 201 || status === 200;
        },
      }).then((res) => {
        if (res.status === 200) {
          setLoading(false);
          setAdd(true);
        } else {
          swal({
            text: "Opps! Something went wrong, While adding to cart",
            button: {
              text: "ok",
              className: "swal-btn",
            },
            className: "swal-alert",
            icon: "warning",
          });
        }
      });
    } else {
      if (!localStorage.getItem("cart")) {
        const cartItemDetail = [
          {
            product_id: props.id,
            quantity: quantity,
            name: props.name,
            veg: props.veg,
            mrp: props.mrp,
            sellingPrice: props.sellingPrice,
            coverImage: props.coverImage,
            unit: props.unit,
            packaged: props.packaged,
          },
        ];
        localStorage.setItem("cart", JSON.stringify(cartItemDetail));
        // EncryptCartData(cartItemDetail);
        setLoading(false);
        setAdd(true);
      } else {
        const cartArr = JSON.parse(localStorage.getItem("cart"));
        // const cartArr = DecryptCartData();
        console.log(cartArr);
        const newCartItem = {
          product_id: props.id,
          quantity: quantity,
          name: props.name,
          veg: props.veg,
          mrp: props.mrp,
          sellingPrice: props.sellingPrice,
          coverImage: props.coverImage,
          unit: props.unit,
          packaged: props.packaged,
        };
        cartArr.push(newCartItem);
        localStorage.setItem("cart", JSON.stringify(cartArr));
        // EncryptCartData(newCartItem);
        setLoading(false);
        setAdd(true);
      }
    }
  };

  return (
    <div className="product-card-2">
      <a href={`/product-detail/${props.id}`} className="product-a">
        <div className="product-img">
          <img
            src={`${imageLocation}${props.coverImage}`}
            alt={`${props.name}`}
          />
        </div>
      </a>
      <div className="product-detail">
        <a href={`/product-detail/${props.id}`}>
          <h4>{props.name}</h4>
        </a>
        <div className="price">
          <h4>
            ₹{props.sellingPrice}
            {!props.packaged && <h4>/{props.unit}</h4>}
          </h4>
          {props.sellingPrice !== props.mrp && (
            <div>
              {!props.packaged ? (
                <p>
                  ₹{props.mrp}/{props.unit}
                </p>
              ) : (
                <p>₹{props.mrp}</p>
              )}
            </div>
          )}

          {props.veg && props.veg !== "" ? (
            <img src={vegIcon} alt="veg-icon" className="veg-icon" />
          ) : (
            <img src={nonVegIcon} alt="non-veg-icon" className="veg-icon" />
          )}
        </div>
        <a href={`/company/${props.company}`}>
          <h5>by {props.company}</h5>
        </a>
        <div className="ratting">
          <div className="star">
            <div className="star-div">
              <p>{props.ratting}</p>
              <img src={starIcon} alt="star-icon" width="12px" height="12px" />
            </div>
            <p>({props.rattingPerson})</p>
          </div>
          {props.stock ? (
            !add ? (
              loading ? (
                <div className="add-cart rotate">
                  <img src={loadingIcon} alt="loading-cart-icon" width="35px" />
                </div>
              ) : (
                <div className="add-cart" onClick={handleAddToCart}>
                  <img src={cartIcon} alt="add-cart-icon" width="35px" />
                </div>
              )
            ) : (
              <div className="add-cart">
                <img src={addedIcon} alt="add-cart-icon" width="35px" />
              </div>
            )
          ) : (
            <div className="add-cart">
              <img src={notAvailable} alt="add-cart-icon" width="35px" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
